module.exports = __webpack_public_path__ + "img/ic-tf-active.4e48dd67.svg";